import {useSelector} from 'react-redux'
import {getAnchorComplete} from 'modules/sapiSearch/selectors'

import {Page} from '@vio/core/src/analytics/types/Events'
import {useToggle} from '@vio/core/src/experiments/hooks/useToggle'
import {getIsGhaChecker} from '@vio/core/src/rateChecker/selectors'

interface Props {
  isAnchor: boolean
  page: Page
}

/**
 * Returns whether to show the anchor loading skeleton for the top offer:
 * until the anchor hotel's offers are complete, always for rate checkers
 * and behind feature-top-offer-delay for normal traffic.
 */
export const useTopOfferDelay = ({isAnchor, page}: Props) => {
  const isRateChecker = useSelector(getIsGhaChecker)
  const toggle = useToggle()
  const isAnchorComplete = useSelector(getAnchorComplete)

  if (!isAnchor || page === Page.Accommodation) return false

  const isDelayEnabled =
    isRateChecker || toggle('feature-top-offer-delay', false, true)

  return isDelayEnabled && !isAnchorComplete
}
